module.exports = __webpack_public_path__ + "media/02_ASANBudapest-Custom02.79924575.mp3";